<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps({
    color: {
        type: String,
        default: '#333'
    },
});

const color = computed(() => props.color);
</script>

<template>
<svg id="_レイヤー_2" data-name="レイヤー 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.39 29.39">
    <g id="design">
        <g>
            <path class="cls-1" d="m14.7,0c-3.99,0-4.49.02-6.06.09-1.56.07-2.63.32-3.57.68-.98.37-1.87.95-2.6,1.69-.75.73-1.33,1.62-1.69,2.6-.36.93-.61,2-.68,3.57-.07,1.57-.09,2.07-.09,6.06s.02,4.49.09,6.06c.07,1.56.32,2.63.68,3.57.37.98.95,1.87,1.69,2.6.82.82,1.64,1.32,2.6,1.69.93.36,2,.61,3.57.68,1.57.07,2.07.09,6.06.09s4.49-.02,6.06-.09c1.56-.07,2.63-.32,3.57-.68.98-.37,1.87-.95,2.6-1.69.82-.82,1.32-1.64,1.69-2.6.36-.93.61-2,.68-3.57.07-1.57.09-2.07.09-6.06s-.02-4.49-.09-6.06c-.07-1.56-.32-2.63-.68-3.57-.37-.98-.95-1.87-1.69-2.6-.73-.75-1.62-1.33-2.6-1.69-.93-.36-2-.61-3.57-.68-1.57-.07-2.07-.09-6.06-.09Zm0,2.65c3.92,0,4.39.02,5.94.09,1.43.07,2.21.3,2.73.51.69.27,1.18.59,1.69,1.1.51.51.83,1,1.1,1.69.2.52.44,1.3.51,2.73.07,1.55.09,2.01.09,5.94s-.02,4.39-.09,5.94c-.07,1.43-.3,2.21-.51,2.73-.24.64-.61,1.22-1.1,1.69-.51.51-1,.83-1.69,1.1-.52.2-1.3.44-2.73.51-1.55.07-2.01.09-5.94.09s-4.39-.02-5.94-.09c-1.43-.07-2.21-.3-2.73-.51-.64-.24-1.22-.61-1.69-1.1-.49-.47-.86-1.05-1.1-1.69-.2-.52-.44-1.3-.51-2.73-.07-1.55-.09-2.01-.09-5.94s.02-4.39.09-5.94c.07-1.43.3-2.21.51-2.73.27-.69.59-1.18,1.1-1.69.51-.51,1-.83,1.69-1.1.52-.2,1.3-.44,2.73-.51,1.55-.07,2.01-.09,5.94-.09Z"/>
            <path class="cls-1" d="m14.7,19.6c-2.71,0-4.9-2.19-4.9-4.9,0-2.71,2.19-4.9,4.9-4.9h0c2.71,0,4.9,2.2,4.9,4.9,0,2.71-2.2,4.9-4.9,4.9Zm0-12.46c-4.17,0-7.55,3.38-7.56,7.55,0,4.17,3.38,7.55,7.55,7.56h0c4.17,0,7.55-3.38,7.55-7.55,0-4.17-3.38-7.55-7.55-7.55Zm9.75-.14c0,.99-.8,1.79-1.79,1.79s-1.79-.8-1.79-1.79.8-1.79,1.79-1.79,1.79.8,1.79,1.79"/>
        </g>
    </g>
</svg>
</template>

<style scoped>
.cls-1 {
    fill: v-bind(color);
    fill-rule: evenodd;
    stroke-width: 0px;
}
</style>